import { render, staticRenderFns } from "./explain-result-icons-list.component.vue?vue&type=template&id=1861fb06&scoped=true"
import script from "./explain-result-icons-list.component.vue?vue&type=script&lang=ts"
export * from "./explain-result-icons-list.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-result-icons-list.component.vue?vue&type=style&index=0&id=1861fb06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1861fb06",
  null
  
)

export default component.exports